<app-loader
  [apiCall]="this.apiCall"
  [loader]="true"
  [loaderId]="'chequesListModal'"
  style="min-height: 150px"
>
  @let paymentEntryModels = paymentEntryModels$ | async;

  @if (paymentEntryModels) {
    <div class="row mt-2">
      <div class="col-12 col-md">
        <app-generic-grid
          style="height: 300px; "
          [data]="paymentEntryModels"
          [tabViewName]="'cheques'"
          [isFilterEnabled]="false"
          [initRowSelection]="true"
          [initRowSelectedProperty]="'accountMoveId'"
          [initRowSelectedPropertyValues]="this.paymentEntryModelIds"
        />
      </div>
    </div>
  }

  @if (paymentEntryModels) {
    <ng-container />
  }
</app-loader>





